import React, { useCallback, useEffect, useState } from 'react';
import { getEtkinlikListesi, etkinlikOlustur, etkinlikSil } from '../services/api';

const bugunISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
const simdiSaat = () => {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

const bosForm = () => ({ tarih: bugunISO(), saat: simdiSaat(), adSoy: '', tel: '0', aciklama: 'İBB Etkinliği', kayitTipi: 'ETKINLIK_ARSIVI' });

// Türkçe büyük harfe çevirme — JS'in varsayılan toUpperCase()'i "i" -> "I" yapar (yanlış), Türkçe
// yerel ayarıyla ("tr-TR") i -> İ, ı -> I doğru dönüşür.
const turkceBuyukHarf = (metin) => metin.toLocaleUpperCase('tr-TR');

// Telefon: yalnızca rakam, başında sabit "0", en fazla 11 hane.
const telefonMaskele = (girdi) => {
  const rakamlar = girdi.replace(/\D/g, '');
  const govde = rakamlar.startsWith('0') ? rakamlar.slice(1) : rakamlar;
  return '0' + govde.slice(0, 10);
};

export default function EtkinlikHastaKaydi() {
  const [baslangic, setBaslangic] = useState(bugunISO());
  const [bitis, setBitis] = useState(bugunISO());
  const [kayitlar, setKayitlar] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');

  const [modalAcik, setModalAcik] = useState(false);
  const [form, setForm] = useState(bosForm());
  const [modalHata, setModalHata] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const listeYukle = useCallback(() => {
    setYukleniyor(true);
    getEtkinlikListesi(baslangic, bitis)
      .then(res => setKayitlar(res.data))
      .catch(() => setHata('Kayıtlar yüklenemedi.'))
      .finally(() => setYukleniyor(false));
  }, [baslangic, bitis]);

  // Listeleme yalnızca "Listele" butonuna basınca tetiklenir — tarih değiştirmek tek başına
  // otomatik listelemez (kullanıcı talebi: 2026-07-27). İlk açılışta bir kez yüklenir.
  useEffect(() => {
    listeYukle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const modalAc = () => {
    setForm(bosForm());
    setModalHata('');
    setModalAcik(true);
  };
  const modalKapat = () => setModalAcik(false);

  const kaydet = async (e) => {
    e.preventDefault();
    setModalHata('');
    if (!form.adSoy.trim()) { setModalHata('Hasta adı soyadı zorunludur.'); return; }
    if (!/^0\d{10}$/.test(form.tel)) { setModalHata('Telefon numarası başında sıfır olacak şekilde 11 haneli olmalıdır.'); return; }
    if (form.aciklama.trim().length < 5) { setModalHata('Not alanı en az 5 karakter olmalıdır.'); return; }

    setKaydediliyor(true);
    try {
      await etkinlikOlustur({
        tarih: form.tarih,
        saat: form.saat,
        adSoy: form.adSoy.trim(),
        tel: form.tel,
        aciklama: form.aciklama.trim(),
        kayitTipi: form.kayitTipi,
      });
      setBasari('Kayıt oluşturuldu.');
      modalKapat();
      listeYukle();
    } catch (err) {
      setModalHata(err.response?.data?.hata || 'Kayıt oluşturulamadı.');
    } finally {
      setKaydediliyor(false);
    }
  };

  const sil = async (id) => {
    if (!window.confirm('Bu kaydı silmek istediğinize emin misiniz?')) return;
    setHata(''); setBasari('');
    try {
      await etkinlikSil(id);
      setBasari('Kayıt silindi.');
      listeYukle();
    } catch (err) {
      setHata(err.response?.data?.hata || 'Silme işlemi başarısız.');
    }
  };

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 16, color: 'var(--med-dark)' }}>Etkinlik Hasta Kaydı</h2>

      {hata && <div className="hata-kutu">{hata}</div>}
      {basari && <div className="basari-kutu">{basari}</div>}

      <div className="card" style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>Başlangıç Tarihi</label>
            <input type="date" value={baslangic} onChange={e => setBaslangic(e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>Bitiş Tarihi</label>
            <input type="date" value={bitis} onChange={e => setBitis(e.target.value)} />
          </div>
          <button onClick={listeYukle} className="btn btn-primary">Listele</button>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h3 style={{ color: 'var(--med-dark)', margin: 0 }}>Kayıtlar</h3>
        <button onClick={modalAc} className="btn btn-primary">+ Yeni Kayıt Girişi</button>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {yukleniyor ? <div className="loading">Yükleniyor...</div> : (
          kayitlar.length === 0 ? <div className="empty">Seçilen tarih aralığında kayıt yok.</div> : (
            <table className="veri-tablosu">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>Saat</th>
                  <th>Hasta Adı Soyadı</th>
                  <th>Telefon</th>
                  <th>Not</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {kayitlar.map(k => (
                  <tr key={k.id}>
                    <td>{k.tar ? new Date(k.tar).toLocaleDateString('tr-TR') : '-'}</td>
                    <td>{k.saat}</td>
                    <td>{k.adSoy}</td>
                    <td>{k.tel}</td>
                    <td>{k.aciklama}</td>
                    <td><button onClick={() => sil(k.id)} className="btn btn-danger">Sil</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )
        )}
      </div>

      {modalAcik && (
        <div
          onClick={modalKapat}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(13,43,94,0.35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100,
          }}
        >
          <form onSubmit={kaydet} onClick={e => e.stopPropagation()} className="card" style={{ width: 420, background: '#fff' }}>
            <h3 style={{ marginTop: 0, marginBottom: 14, color: 'var(--med-dark)' }}>Yeni Kayıt Girişi</h3>

            <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Tarih</label>
                <input type="date" value={form.tarih} onChange={e => setForm({ ...form, tarih: e.target.value })} />
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Saat</label>
                <input type="time" value={form.saat} onChange={e => setForm({ ...form, saat: e.target.value })} />
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Hasta Adı Soyadı</label>
              <input
                value={form.adSoy}
                onChange={e => setForm({ ...form, adSoy: turkceBuyukHarf(e.target.value) })}
                placeholder="AD SOYAD"
                style={{ width: '100%', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Telefon No</label>
              <input
                value={form.tel}
                onChange={e => setForm({ ...form, tel: telefonMaskele(e.target.value) })}
                placeholder="05XXXXXXXXX"
                inputMode="numeric"
                maxLength={11}
                style={{ width: '100%', boxSizing: 'border-box' }}
              />
            </div>

            <div style={{ marginBottom: 12, display: 'flex', gap: 18 }}>
              <label style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="kayitTipi"
                  checked={form.kayitTipi === 'ETKINLIK_ARSIVI'}
                  onChange={() => setForm({ ...form, kayitTipi: 'ETKINLIK_ARSIVI' })}
                />
                Etkinlik Arşivi
              </label>
              <label style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="kayitTipi"
                  checked={form.kayitTipi === 'ARANMALI'}
                  onChange={() => setForm({ ...form, kayitTipi: 'ARANMALI' })}
                />
                Aranmalı
              </label>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 4 }}>Not</label>
              <textarea
                value={form.aciklama}
                onChange={e => setForm({ ...form, aciklama: e.target.value })}
                rows={4}
                placeholder="En az 5 karakter..."
                style={{ width: '100%', boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' }}
              />
            </div>

            {modalHata && <div className="hata-kutu">{modalHata}</div>}

            <button type="submit" disabled={kaydediliyor} className="btn btn-primary" style={{ width: '100%', marginBottom: 8 }}>
              {kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
            </button>
            <button type="button" onClick={modalKapat} className="btn btn-secondary" style={{ width: '100%' }}>
              Vazgeç
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
